import { createAsyncAction, createAction } from 'typesafe-actions'
import { GetHistoryRequestDto, GetHistoryResponseDto } from '@sparling/financial-common'

export const {
  request: getHistoryRequest,
  success: getHistorySuccess,
  failure: getHistoryFailure,
} = createAsyncAction('GET_HISTORY_REQUEST', 'GET_HISTORY_SUCCESS', 'GET_HISTORY_FAILURE')<
  GetHistoryRequestDto,
  GetHistoryResponseDto,
  Error
>()

export const setHistoryFilters = createAction('SET_HISTORY_FILTERS')<GetHistoryRequestDto>()
export const resetHistoryFilters = createAction('CLEAR_HISTORY_FILTERS')<void>()
